import React from "react";
import { useTranslation } from "react-i18next";
import LocContactDetails from "./LocContactDetails";
import { formattedNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";

function LocEmergencyNineOne({
  register,
  setValue,
  getValues,
  errors,
  dedicatedNineOneNumbers,
  sameAsPrimlaryFlag,
  watch,
}) {
  const { t, i18n } = useTranslation();
  const isSameAsPrimary = (!getValues("nine_one_one.same_as_primary_contact"));
  const labels = {
    name: "Contact Name",
    email: "Contact Email Address",
    number: "Contact Number"
  };
  return (
    <>
      <div id="emergency911">
        <div className="margin-top mt-2">
          <div className="general-settings">{t("emergency911")}</div>

          <div className="add-numbermain">
            <div className="tel-numbers">
              {t("en911services")}
              <br />
            </div>
            <div className="d-flex">
              <div className="phoneselect">
                <div className="phoneselect">
                  <label className="switch">
                    <input
                      className="form-control"
                      type="checkbox"
                      // {...register("nine_one_one.enable_nine_one_one")}
                      checked={watch("nine_one_one.enable_nine_one_one")}
                      onChange={(e) => {
                        setValue(
                          "nine_one_one.enable_nine_one_one",
                          e.target.checked,
                          {
                            shouldDirty: true,
                          }
                        );
                        if (e.target.checked) {
                          setValue(
                            "nine_one_one.same_as_primary_contact",
                            sameAsPrimlaryFlag,
                            { shouldDirty: true }
                          );
                        }
                      }}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          {getValues("nine_one_one.enable_nine_one_one") && (
            <>
              <div className="add-numbermain">
                <div className="tel-numbers">
                  {t("UsePrimaryContact911Services")}
                  <br />
                </div>
                <div className="d-flex">
                  <div className="phoneselect">
                    <div className="phoneselect">
                      <label className="switch">
                        <input
                          className="form-control"
                          type="checkbox"
                          {...register("nine_one_one.same_as_primary_contact")}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              {isSameAsPrimary &&
                (<LocContactDetails
                  register={register}
                  errors={errors}
                  firstName="nine_one_one.fname"
                  lastName="nine_one_one.lname"
                  email="nine_one_one.email"
                  number="nine_one_one.number"
                  labels={labels}
                />)}
              <div className="add-numbermain">
                <div className="tel-numbers">
                  {t("Dedicated 911 Number for this Location")}
                </div>
                <div className="d-flex w-30">
                  <div className="phoneselect w-100">
                    <select
                      className="form-control form-select selectname w-100"
                      name="--Select a Dedicated number for 911--"
                      value = {watch("nine_one_one.dedicated_nine_one_one_number")}
                      // {...register(
                      //   "nine_one_one.dedicated_nine_one_one_number",
                      //   { required: "Please Select a Dedicated Number for 911" }
                      // )}
                      onChange = {(e) => setValue("nine_one_one.dedicated_nine_one_one_number", e.target.value, {shouldDirty: true})}
                    >
                      {/* <option
                        value={getValues(
                          "nine_one_one.dedicated_nine_one_one_number"
                        )}
                      >
                        {getValues(
                          "nine_one_one.dedicated_nine_one_one_number"
                        )}
                      </option> */}
                      <option value={""}>Select a Dedicated Number for 911</option>
                      {/* <option
                        value={getValues(
                          "nine_one_one.dedicated_nine_one_one_number"
                        )}
                      >
                        {getValues(
                          "nine_one_one.dedicated_nine_one_one_number"
                        )}
                      </option> */}
                      {dedicatedNineOneNumbers &&
                        Object.entries(dedicatedNineOneNumbers).map(
                          ([key, value]) => <option value={key}>{formattedNumber(value)}</option>
                        )}
                    </select>
                    {errors?.nine_one_one?.dedicated_nine_one_one_number && (
                      <p className="text-danger">
                        {
                          errors?.nine_one_one?.dedicated_nine_one_one_number
                            .message
                        }
                      </p>
                    )}
                    {/* <input className="form-control" type="checkbox" value="Include Users and Supervisors" /> */}
                  </div>
                </div>
              </div>
              <div className="add-numbermain">
                <div className="tel-numbers">{t("Specific Location")}</div>
                <div className="d-flex w-30">
                  <div className="w-100">

                    <input
                      type="text"
                      {...register("nine_one_one.specific_location",
                        { required: "Specific Locaton is required" }
                      )}
                      className="selectname w-100"
                    />
                    {/* <input className="form-control" type="checkbox" value="Include Users and Supervisors" /> */}
                    {errors?.nine_one_one?.specific_location && (
                      <p className="text-danger d-block">
                        {errors?.nine_one_one?.specific_location.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default LocEmergencyNineOne;
